/**
* @author Algirdas Noreika, Indeform Ltd
* @copyright Copyright 2018, Indeform Ltd. DO NOT EDIT/USE WITHOUT PERMISSION
* @version 20180810
* @description Main UI components manager.
*/


let DOM = null;

class UI {
    static $ID(id) { return DOM.getElementById(id); }

    constructor(core, dom = null) {
        this.core = core;
        DOM = (dom === null ? document : dom);
        this._components = {};

        console.log("UI: OK");
    }

    // Registering and unregistering components within UI. Components can be initialized only if registered.
    registerComponent(compClass, params = {}) {
        let compId = compClass.name;

        this._components[compId] = {
            componentClass: compClass,
            component: null,
            params: params
        }

        this.initializeComponent(compId);

        return this._components[compId].component;
    }


    unregisterComponent(compId) {
        this.disposeComponent(compId);

        delete this._components[compId];
    }


    initializeComponent(compId) {
        let compClass = this._components[compId].componentClass;
        let comp = new compClass(this, this._components[compId].params);

        if ( comp.isAttachedToElement() ) {
            // if not null and same ELEMENT do nothing else dispose existing Component and initialize the new one.
            if (this._components[compId].component !== null && this._components[compId].component.isElementMatching(comp)) {
                comp.dispose();
            } else {
                this.disposeComponent(compId);
                this._components[compId].component = comp;

                // configurable: true - redefines object property again
                Object.defineProperty(this, compId, {
                    configurable: true,
                    get() { return comp; },
                });

                comp.activateEventsHandling();
            }
        } else {
            comp.dispose();
            this.disposeComponent(compId);
        }
    }


    disposeComponent(compId) {
        let comp = this._components[compId].component;

        if (comp !== null) comp.dispose();

        this._components[compId].component = null;
    }


    update() {
        for (let compId in this._components) {
            this.initializeComponent(compId);
        }
    }


    isComponent(compId) {
        if (this._components[compId] == undefined) return false;

        return true;
    }


    getComponent(compId) {
        return this._components[compId].component;
    }
}


export { UI }
export default UI



//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/core/ui.js
// module id = 132
// module chunks = 0